const RNDR = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 2091 2500"
    {...props}
  >
    <g id="Layer_x0020_1">
      <g id="_1705569976288">
        <g>
          <polygon
            className="st0"
            points="0,2499.8 0,2215.3 426.2,2215.3 426.2,2237.8 22.6,2237.8 22.6,2499.8    "
          ></polygon>
          <polygon
            className="st0"
            points="545.3,2499.8 545.3,2216.5 976.6,2216.5 976.6,2499.8 954,2499.8 954,2239.1 567.9,2239.1      567.9,2499.8    "
          ></polygon>
          <path d="M1546.9,2216.5v283.3h-427.5v-209.4h404.9v-74H1546.9z M1524.4,2477.3v-163H1142v163H1524.4z"></path>
          <polygon
            className="st0"
            points="1664.8,2499.8 1664.8,2215.3 2091,2215.3 2091,2237.8 1687.3,2237.8 1687.3,2499.8    "
          ></polygon>
        </g>
        <g>
          <path
            className="st0"
            d="M1045.5,596.9c203.1,0,368.6,165.5,368.6,368.6S1248.6,1334,1045.5,1334s-368.6-165.5-368.6-368.6     S842.4,596.9,1045.5,596.9z"
          ></path>
          <path
            className="st0"
            d="M1054.3,0.2c116.6,1.3,230.7,23.8,337.2,63.9c106.6,41.4,206.8,101.5,293.3,178l2.5,2.5l0,0     c198.1,176.8,305.9,416.2,320.9,661.9c15,247-63.9,498.9-240.7,698.3l-2.5,2.5l0,0c-176.8,198.1-416.2,305.9-661.9,320.9     c-247,15-498.9-63.9-698.3-240.7S96.5,1270.1,81.5,1023.1s63.9-498.9,240.7-698.3l84,74c-156.7,176.8-225.6,399.9-213.1,618     c13.8,218.1,109.1,431.2,285.8,586.7c176.8,156.7,399.9,225.6,618,213.1c218.1-13.8,431.2-109.1,586.7-285.8l2.5-2.5l0,0     c154.2-175.5,224.4-397.4,210.6-615.5s-109.1-431.2-285.8-586.7l-2.5-2.5l0,0c-76.5-67.7-164.2-119.1-257-155.4     c-94-36.4-195.6-56.4-298.4-56.4L1054.3,0.2z"
          ></path>
          <path d="M496.4,6.4c66.4,0,127.9,27.6,171.7,71.5c43.9,43.9,71.5,104,71.5,171.7c0,66.4-27.6,127.9-71.5,171.7     c-43.9,43.9-104,71.5-171.7,71.5c-66.4,0-127.9-27.6-171.7-71.5s-71.5-104-71.5-171.7c0-66.4,27.6-127.9,71.5-171.7     S428.7,6.4,496.4,6.4z M587.9,156.9c-23.8-23.8-56.4-37.6-91.5-37.6c-36.4,0-68.9,15-91.5,37.6c-23.8,23.8-37.6,56.4-37.6,91.5     c0,36.4,15,68.9,37.6,91.5c23.8,23.8,56.4,37.6,91.5,37.6c36.4,0,68.9-15,91.5-37.6c23.8-23.8,37.6-56.4,37.6-91.5     C625.5,212,610.5,179.4,587.9,156.9z"></path>
        </g>
      </g>
    </g>
  </svg>
);
export default RNDR;
